/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2026-01-22 15:54:31
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2026-03-22 17:56:12
 * @FilePath: /knit-web/src/router/routes/modules/deploy.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { DEFAULT_LAYOUT } from '@/router/constants';
import { AppRouteRecordRaw } from '../types';

const ROUTERS: AppRouteRecordRaw = {
  path: '/deploy',
  name: 'Deploy',
  component: DEFAULT_LAYOUT,
  redirect: '/deploy/database',
  meta: {
    locale: 'menu.deploy.title',
    requiresAuth: false,
    hideFirstMenu: true,
    order: 20,
  },
  children: [
    {
      path: 'database',
      name: 'Database',
      component: () => import('@/views/database/index.vue'),
      meta: {
        locale: 'menu.deploy.database.title',
        requiresAuth: true,
        icon: 'icon-database',
        roles: ['*'],
      },
    },
    {
      path: 'database/mysql/:instanceId',
      name: 'MysqlInstanceDetail',
      component: () => import('@/views/database/mysql/detail/index.vue'),
      meta: {
        locale: 'menu.deploy.database.mysql',
        requiresAuth: true,
        roles: ['*'],
        hideInMenu: true,
      },
    },
    {
      path: 'database/mysql/database',
      name: 'MysqlDatabaseDetail',
      component: () =>
        import('@/views/database/mysql/detail/database/index.vue'),
      meta: {
        locale: 'menu.deploy.database.mysql',
        requiresAuth: true,
        roles: ['*'],
        hideInMenu: true,
      },
    },
    {
      path: 'database/redis/:instanceId',
      name: 'RedisInstanceDetail',
      component: () => import('@/views/database/redis/detail.vue'),
      meta: {
        locale: 'database.redis.manage',
        requiresAuth: true,
        roles: ['*'],
        hideInMenu: true,
      },
    },
    {
      path: 'database/postgres/:instanceId',
      name: 'PostgresInstanceDetail',
      component: () => import('@/views/database/postgres/detail/index.vue'),
      meta: {
        locale: 'menu.deploy.database.postgres',
        requiresAuth: true,
        roles: ['*'],
        hideInMenu: true,
      },
    },
    {
      path: 'database/postgres/database',
      name: 'PostgresDatabaseDetail',
      component: () =>
        import('@/views/database/postgres/detail/database/index.vue'),
      meta: {
        locale: 'menu.deploy.database.postgres',
        requiresAuth: true,
        roles: ['*'],
        hideInMenu: true,
      },
    },
    {
      path: 'database/milvus/:instanceId',
      name: 'MilvusInstanceDetail',
      component: () => import('@/views/database/milvus/detail/index.vue'),
      meta: {
        locale: 'menu.deploy.database.milvus',
        requiresAuth: true,
        roles: ['*'],
        hideInMenu: true,
      },
    },
    {
      path: 'database/milvus/collection',
      name: 'MilvusCollectionDetail',
      component: () =>
        import('@/views/database/milvus/detail/collection/index.vue'),
      meta: {
        locale: 'menu.deploy.database.milvus',
        requiresAuth: true,
        roles: ['*'],
        hideInMenu: true,
      },
    },
    {
      path: 'knowledge',
      name: 'KnowledgeIndex',
      component: () => import('@/views/knowledge/index.vue'),
      meta: {
        icon: 'icon-knowledge',
        locale: 'menu.deploy.knowledge.title',
        requiresAuth: true,
        roles: ['*'],
        order: 10,
      },
    },
    {
      path: 'knowledge/instance/:id',
      name: 'KnowledgeInstanceDetail',
      component: () => import('@/views/knowledge/detail/index.vue'),
      meta: {
        locale: 'menu.deploy.knowledge.knowledgeDetail',
        requiresAuth: true,
        roles: ['*'],
        hideInMenu: true,
      },
    },
    {
      path: 'knowledge/kb/:kbId',
      name: 'KnowledgeBaseDetail',
      component: () => import('@/views/knowledge/kb-detail/index.vue'),
      meta: {
        locale: 'menu.deploy.knowledge.knowledgeBaseDetail',
        requiresAuth: true,
        roles: ['*'],
        hideInMenu: true,
      },
    },
    {
      path: 'knowledge/document/:docId',
      name: 'KnowledgeDocumentDetail',
      component: () => import('@/views/knowledge/doc-detail/index.vue'),
      meta: {
        locale: 'menu.deploy.knowledge.knowledgeDocumentDetail',
        requiresAuth: true,
        roles: ['*'],
        hideInMenu: true,
      },
    },
    {
      path: 'apps',
      name: 'Apps',
      component: () => import('@/views/apps/index.vue'),
      meta: {
        locale: 'menu.deploy.apps',
        requiresAuth: true,
        icon: 'icon-apps',
        roles: ['*'],
        order: 20,
      },
    },
    {
      path: 'apps/:appId',
      name: 'AppDetail',
      component: () => import('@/views/apps/detail/index.vue'),
      meta: {
        locale: 'menu.deploy.apps',
        requiresAuth: true,
        roles: ['*'],
        hideInMenu: true,
      },
    },
  ],
};

export default ROUTERS;
